import React, { useEffect, useState } from 'react'
import '../../scss/pages/Login/Login.scss'
import EarnRewards from '../../asset/image/Earn Rewards.png'
import logo from '../../asset/svg/Logo.svg'
import comp from '../../asset/svg/Comp.svg'
import OTPInput, { ResendOTP } from "otp-input-react";
import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import { useDispatch, useSelector } from 'react-redux'
import { AUTH_REQUEST, VERIFY_OTP } from '../../sagas/type'
import { useNavigate } from 'react-router-dom'
import { getLocalStoreString } from '../../utils/Helper'
import { useSnackbar } from 'notistack'
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import editIcon from '../../asset/svg/editIcon.svg'


function Login() {

  const [phoneNumber, setPhoneNumber] = useState('');
  const [verify, setVerify] = useState(true)
  const [OTP, setOTP] = useState("");
  const [error, setError] = useState(false)
  const [errorContent, setErrorContent] = useState('')
  const [otpError, setOtpError] = useState(false)

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const nextStep = () => {
    setVerify(false)
  }

  const handleFormSubmit = () => {
    const Mobile = `+${phoneNumber}`
    dispatch({
      type: AUTH_REQUEST,
      Payload: { Mobile },
      nextStep,
      setError,
      setErrorContent,
      enqueueSnackbar: enqueueSnackbar,
    });
  };

  const handleVerifyOtp = () => {
    const employeeID = getLocalStoreString('EmployeeID');
    dispatch({
      type: VERIFY_OTP,
      Payload: {
        EmployeeID: employeeID,
        OTP: OTP,
      },
      setOtpError,
      enqueueSnackbar: enqueueSnackbar,
      navigate: navigate
    });
  }

  const handleNavigate = () => {
    setError(false);
    setErrorContent('');
    setOtpError(false)
    setOTP('')
    setVerify(true);
  }

  const handleNumber = (number) => {
    setError(false)
    setPhoneNumber(number)
  }
  const handleOtp = (otp) => {
    setOtpError(false)
    setOTP(otp)
  }

  return (
    <main className='login-container'>
      <section className='login-container_section' >
        <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" minWidth="100%" paddingY="2rem"  >
          <img width="150px" src={logo} className='' alt='' />
          <img width="150px" src={comp} className='' alt='' />
          <Typography color="white" paddingY="1rem" >Perform at work &</Typography>
          <img width="200px" src={EarnRewards} className='' alt='' />
        </Box>
        {verify ? <Box position="absolute" bottom={0} display="flex" justifyContent="center" alignItems="center" flexDirection="column" width="100%" paddingY="3rem" bgcolor="white" className='login-container_section_verifyBox'>
          <Typography color="black" variant='h6' fontWeight={600} >Sign In to Continue</Typography>
          <PhoneInput onlyCountries={['in', 'us']} countryCodeEditable={false} inputStyle={{ border: error ? "1px solid red" : "" }} buttonStyle={{ border: error ? "1px solid red" : "" }} placeholder='Enter Mobile Number' country='in' value={phoneNumber} inputClass={{ fontWeight: 'bold' }} style={{ width: '80%', marginTop: '1rem', borderRadius: '5px' }} onChange={(number) => handleNumber(number)} />
          {error && <Typography className='login-container_section_verifyBox_errorText' color="#FC7C7C">{errorContent}</Typography>}
          <button disabled={phoneNumber?.length <= 11} type='submit' className={`${phoneNumber?.length <= 11 ? 'login-container_section_verifyBox_disable-button' : 'login-container_section_verifyBox_active-button'}`} onClick={handleFormSubmit}>Send OTP</button>
        </Box> :
          <Box position="absolute" bottom={0} display="flex" justifyContent="center" alignItems="center" flexDirection="column" width="100%" paddingY="3rem" bgcolor="white" className='login-container_section_verifyBox'>
            <div style={{ marginLeft: '17rem' }}>
              <ResendOTP renderTime={() => React.Fragment}
                renderButton={(buttonProps) => {
                  return (
                    <button {...buttonProps} style={buttonProps.remainingTime !== 0 ? { border: 'none', backgroundColor: 'white', position: 'absolute', top: '22px', right: '10px', cursor: 'pointer' } : { border: 'none', backgroundColor: 'white', color: "#6146F2", position: 'absolute', top: '22px', right: '10px', cursor: 'pointer' }} onClick={handleFormSubmit}>
                      {buttonProps.remainingTime !== 0 ? `00:${buttonProps.remainingTime}` : "Resend"}
                    </button>
                  );
                }}
              /></div>
            <div style={{ position: 'relative', bottom: '1rem' }}>
              <Typography color="black" variant='h6' fontWeight={700} position='relative' top='-1rem' >Verify using OTP</Typography>
              <Typography position='relative' top='-1rem' color='#0E0E0E' fontSize='13px' >Sent to<span style={{ color: 'black', fontWeight: '700' }}> {phoneNumber && phoneNumber.length > 10 && `+${phoneNumber}`}</span> </Typography>
              <img src={editIcon} alt='' style={{ position: 'absolute', right: '3px', top: '19px', cursor: "pointer" }} onClick={handleNavigate} />
            </div>
            <OTPInput value={OTP && OTP} inputStyles={otpError && { border: '1px solid #FC7C7C' }} otpType="number" disabled={false} secure={false} onChange={(otp) => handleOtp(otp)} OTPLength={6} className='login-container_section_verifyBox_otp-input' />
            {otpError && <Typography color="#FC7C7C">Please enter the correct OTP</Typography>}
            <button type='submit' className='login-container_section_verifyBox_active-button' onClick={handleVerifyOtp}>Verify</button>
          </Box>}
      </section>
    </main >
  )
}

export default Login;